import creteleadtext from "../../../assets/icons/creteleadtext.svg";
import creteleadvoice from "../../../assets/icons/creteleadvoice.svg";
import { routes } from "../../../constants/routes";
import uploadArrow from "../../../assets/icons/upload-arrow.svg";
import uploadLink from "../../../assets/icons/link-url.svg";

export const filterOptions = [
  // {
  //   labels:"Assigned Partner",
  //   value:false,
  // },
  {
    labels: "Lead Value",
    value: false,
  },
  {
    labels: "Confidence Score",
    value: false,
  },
  {
    labels: "City",
    value: false,
  },
  // {
  //   labels: "Company",
  //   value: false,
  // },
  {
    labels: "Created By",
    value: false,
  },
  {
    labels: "Created Time",
    value: false,
  },
  {
    labels: "Fax",
    value: false,
  },
  {
    labels:"Lead Owner",
    value:false,
  },
   {
    labels: "Lead Status",
    value: false,
  },
  {
    labels: "Industry",
    value: false,
  },
  {
    labels: "Last Activity Time",
    value: false,
  },
  // {
  //   labels: "Converted Contact",
  //   value: false,
  // },
  // {
  //   labels: "Converted Account",
  //   value: false,
  // },
  // {
  //   labels: "Converted Deal",
  //   value: false,
  // },
  {
    labels: "Country",
    value: false,
  },
  {
    labels: "Email",
    value: false,
  },
  // {
  //   labels: "Email Opt Out",
  //   value: false,
  // },
  {
    labels: "First Name",
    value: false,
  },
  {
    labels: "Last Name",
    value: false,
  },
];
export const CREATED_TIME_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "This Week", value: "This Week" },
  { label: "This Month", value: "This Month" },
  { label: "Last Week", value: "Last Week" },
  { label: "Last Month", value: "Last Month" },
  { label: "Custom", value: "Custom" },
];

export const allLeadsOptions = [
  { value: "All Leads", id: 0, styleName: "bold-option" },
  { value: "Converted Leads", id: 1 },
  { value: "My Converted Leads", id: 2 },
  { value: "My Leads", id: 3 },
  { value: "Not Qualified Leads", id: 4 },
  { value: "Open leads", id: 5 },
  { value: "Recently Modified Leads", id: 6 },
  { value: "Today’s Leads", id: 7 },
];

export const createLeadsOptions = [
  { value: "Import Leads", id: 1 },
  { value: "Social Media Import", id: 2 },
];

export const createLeadsButtonOptions = (setIsShowCreateLead: any, isShowCreateLead: any, isShowCreateLeadSection: any, setIsShowCreateLeadSection: any) => {
  return [
    {
      value: "Text", id: 1, icon: creteleadtext, onClick: () => {
        setIsShowCreateLeadSection(!isShowCreateLeadSection);
      }
    },
    {
      value: "Voice", id: 2, icon: creteleadvoice, onClick: () => {
        setIsShowCreateLead(!isShowCreateLead);
      }
    },
  ]
}

export const actionsOptions = [
  { value: "Archive", id: 1 },
  { value: "Update", id: 2 },
  { value: "Convert", id: 3 },
  { value: "Export Leads", id: 5 },
  { value: "Add to Campaigns", id: 6 },
];

export const leadActionScope = [
  { value: "All Leads" },
  { value: "Selected Leads" },
];

export const leadEditableFields = [
  { label: "Lead Value", id: 1, value: "leadValue" },
  { label: "Confidence Score", id: 3, value: "confidenceScore" },
  { label: "Description", id: 4, value: "description" },
  { label: "Fax Number", id: 5, value: "faxNumber" },
  { label: "Industry", id: 6, value: "industry" },
  { label: "Interested Product", id: 7, value: "interestedProducts" },
  { label: "Lead Owner", id: 8, value: "leadOwner" },
  { label: "Lead Status", id: 10, value: "leadStatus" },
  { label: "Social Lead ID", id: 12, value: "socialLeadId" },
  { label: "Website URL", id: 13, value: "website" },
];

export const uploadAttachmentsOptions = [
  {
    label: "Upload Files",
    value: "uploadFile",
    id: 1,
    icon: uploadArrow,
  },
  {
    label: "Link URL",
    value: "linkUrl",
    id: 2,
    icon: uploadLink,
  },
];

export const addCallOptions= [
  {
    label: "Schedule Call",
    value: "scheduleCall",
    id: 1
  },
  {
    label: "Log Call",
    value: "logCall",
    id: 2
  },
];

export const emailComposeOptions = [
  {
    id: 1,
    label: "Select from Templates",
    value: "Select from Templates"
  },
  {
    id: 2,
    label:"Compose New Mail",
    value:"Compose New Mail"
  }
]

export const letterComposeOptions = [
  {
    id: 1,
    label: "Select from Templates",
    value: "Select from Templates"
  },
  {
    id: 2,
    label:"Compose New Letter",
    value:"Compose New Letter"
  }
]